import useAnalytics from "hooks/useAnalytics";

import { ANALYTICS } from "./constants";

const useIdpGroupRolesListAnalytics = () => {
  return useAnalytics({
    page: ANALYTICS.analyticsPage,
  });
};

export default useIdpGroupRolesListAnalytics;
